import { Component, OnInit, Inject, HostListener,} from '@angular/core';
import { DOCUMENT} from '@angular/common';
import {BehaviorSubject, Observable} from 'rxjs';
@Component({
  selector: 'app-view-define',
  templateUrl: './view-define.component.html',
  styleUrls: ['./view-define.component.scss']
})
export class ViewDefineComponent implements OnInit {
  openSidenav: boolean = true;
  mode: any;
  showToggle!: boolean;
  position!: any;
  value:any=100;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth$.next(event.target.innerWidth);
  };
  private screenWidth$ = new BehaviorSubject < number > (window.innerWidth);
  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.handleSidenav();
  }
  onWindowScroll(e:Event) {

    let scroll = (e.target as Element).scrollTop;
    let offsetHeight = document.getElementById('header')!.offsetHeight;
    var contentHeight = scroll - offsetHeight;
     if (contentHeight>20) {
      let element = this.document.getElementById('header');
      let elem2 = this.document.getElementById('side-nav');
      element?.classList.add('fixed-header');
       if(elem2?.classList.contains('mat-drawer-opened')) {
        element?.classList.remove('w-full');
       }else {
        element?.classList.add('w-full');
       }
     }
     else if(scroll==0) {
      let element = this.document.getElementById('header');
        element?.classList.remove('fixed-header');
        element?.classList.remove('w-full');
     }
  }


  handleSidenav() {
    this.getScreenWidth().subscribe(width => {
      if (width < 992) {
        this.showToggle = true;
        this.mode = 'over';
        this.openSidenav = false;
        this.position = 'end'
      } else if (width > 992) {
        this.showToggle = false;
        this.mode = 'side';
        this.openSidenav = true;
        this.position = 'start'
      }
    });
  }
  getScreenWidth(): Observable < number > {
    return this.screenWidth$.asObservable();
  }
}
